// extracted by mini-css-extract-plugin
module.exports = {"image-holder":"ShowImage_image-holder__2jY3L","image":"ShowImage_image__1xmXx"};